export default __webpack_public_path__ + "static/Mobile-3aac71a569d6ff621c73eeed09ca8980.png";